// extracted by mini-css-extract-plugin
module.exports = {"container":"PromotionSectionWrapper-module--container--1qnyb"};